import { agents } from './dashboard.js';

/**
 * Mock agent fleet — exactly the 10 dashboard.js agents (ATLAS→WARDEN, ids
 * 1–10), per shared/roster.json (go-live-readiness.md §4). The previous spec
 * roster here (Sage/Aegis/Compass/Prism at ids 7–10) collided with the
 * dashboard vocabulary and produced a 14-entry list with duplicate ids —
 * dropped; mocks/brain.js is remapped to the same roster. Consumers
 * (useConsoleLogStream demo feed, mocks/channels.js enabledAgentIds) index
 * this list and must never see duplicate ids again.
 */
export const initialAgents = [...agents];
